import { mark, clearMarks } from './performance';
export var PAGE_TRANSITION_MARK = 'ad_tracker_page_transition';

var markPageTransition = function markPageTransition(performance) {
  try {
    clearMarks(PAGE_TRANSITION_MARK, performance);
    mark(PAGE_TRANSITION_MARK, performance);
  } catch (err) {
    console.error(err);
  }
};

export default markPageTransition;
//# sourceMappingURL=markPageTransition.js.map